import { EntityUIQuery, QueryEntity } from "@datorama/akita";
import { Injectable, Inject } from "@angular/core";
import { TransactionExtendedState, TransactionExtendedStore, TransactionExtendedUIState } from "./transaction-extended.store";
import * as moment from "moment";
import { TransactionExtended, TransactionExtendedItem } from "./transaction.extended.model";
import { DATE_OPTIONS } from "../../shared/date-option";
import { DateOptions } from "../../shared/models/date-options.model";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TransactionExtendedQuery extends QueryEntity<TransactionExtendedState>{
    ui: EntityUIQuery<TransactionExtendedUIState>;

    transactions$ = this.selectAll();
    groupedByDate$: Observable<{ date: string, transactions: TransactionExtended[] }[]> = this.selectAll().pipe(map(this._groupByDate()));
    loading$ = this.selectLoading();

    constructor(@Inject(DATE_OPTIONS) private dateFormat: DateOptions, 
                protected store: TransactionExtendedStore){
        super(store);
        this.createUIQuery();
    }

    isLoading(id: number): Observable<boolean>{
      return this.ui.selectEntity(id, 'isLoading')
        .pipe(
          map(val => val as boolean));
    }

    isDisabled(id: number): boolean{
      return !this.getEntity(id)?.ExternalVendorRef;
    }

    getItemDetailsByTref(id: number): Observable<TransactionExtendedItem[]>{
      return this.select(state => state.itemDetails[id] || undefined);
    }

    hasItemDetails(id: number): boolean{
      return !!this.getValue().itemDetails[id];
    }

    private _groupByDate(): any{
        return (arr: TransactionExtended[]) => {
    
          const uniqueDates = arr.sort(this._sortByDate())
            .filter((val: TransactionExtended, idx: number, a: TransactionExtended[]) => a.findIndex(i =>  this._formatDate(i.TransactionDateUTC) ===  this._formatDate(val.TransactionDateUTC)) === idx)
            .map(i => this._formatDate(i.TransactionDateUTC));
    
          return uniqueDates.map(date => ({ date, transactions: arr.filter(i => this._formatDate(i.TransactionDateUTC) === date).sort(this._sortByDate()) }));
        }
    }

    private _sortByDate(){
        return (a: TransactionExtended, b: TransactionExtended) => new Date(b.TransactionDateUTC).getTime() - new Date(a.TransactionDateUTC).getTime();
    }

    private _formatDate(date: any): string{
       return moment(date).format(this.dateFormat.NgbDateFormat);
    }
}